module.exports = __webpack_public_path__ + "images/content-section/Illustration-Truck-Boat-Car.svg";